// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./app/widgets/navigation/menu/app/css/app.css
// module id = 504
// module chunks = 0